module.exports = __webpack_public_path__ + "static/img/bg_02.c445869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_02.jpg
// module id = RGHt
// module chunks = 3